/** Her kelimenin ilk harfini Turkce kurallarina gore buyutur. */
export function formatTitleCaseTr(value: string | null | undefined): string {
  if (value == null || value === "") return value ?? "";
  return value
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .map((word) => {
      const lower = word.toLocaleLowerCase("tr-TR");
      return lower.charAt(0).toLocaleUpperCase("tr-TR") + lower.slice(1);
    })
    .join(" ");
}
